import { HIDE_BUTTON, SHOW_BUTTON, LOCK_SCRIPT } from './mutations'

export const ACTION_SHOW_BUTTON = 'ACTION_SHOW_BUTTON'
export const ACTION_HIDE_BUTTON = 'ACTION_HIDE_BUTTON'
export const ACTION_LOCK_SCRIPT = 'ACTION_LOCK_SCRIPT'

export const actions = {
  [ACTION_LOCK_SCRIPT]: function ({ commit }) {
    commit(LOCK_SCRIPT)
  },
  [ACTION_SHOW_BUTTON]: function ({ commit }) {
    commit(SHOW_BUTTON)
  },
  [ACTION_HIDE_BUTTON]: function ({ commit }) {
    commit(HIDE_BUTTON)
  },
}
